(ns app.front.ui.multi-select-tags
  (:require [app.front.ui.select :as ui-select]
            [app.front.ui.tags :as ui-tags]
            [app.front.util :as futil]
            [core.front.icons :as i]
            [core.util.util :as util]
            [reagent.core :as r]))


(defn multi-select-tags
  "Make a select component that operates on a sequence of arbitrary values (not just
   strings) and allows multiple options to be selected.

   Differs from plain multi-select that the results are displayed as tags outside the
   selection dropdown itself.

   Nil represents no values selected and is permitted.
   Otherwise the value should be a set.

   Required props
   `:tr`, `:id`, `:on-change`, `:label-text`, `:values`, `:val->str`

   Optional props
   `:disabled`       (default false)
   `:value`          (a set, default nil)
   `:select-text`    (a string, default nil)
   `:sort-by-label?` (a boolean, default false)"
  [{:keys [tr id on-change disabled values value label-text val->str sort-by-label? select-text]}]
  (r/with-let [*selected  (r/atom (set value))
               swap-fn!   (fn [operation val]
                            (when (some? val)
                              (swap! *selected operation val)
                              (on-change @*selected)))
               sort-fn    #(cond->> %
                             sort-by-label? (sort-by val->str))]
    (let [unselected (remove @*selected (sort-fn values)) ; Separate let so changes in *selected register
          label-text (str label-text " " (count @*selected) "/" (count values))]
      [:div.bx--form-item
       (if (or disabled (empty? unselected))
         [:div.bx--label label-text]
         [ui-select/select (util/mmap {:id        (str id "-select")
                                       :values    unselected
                                       :disabled  (boolean disabled)
                                       :on-change #(swap-fn! conj %)}
                                      label-text val->str select-text)])
       [:div.flex.flex-wrap
        (futil/for-frag [tag (sort-fn @*selected)]
          [ui-tags/tag
           {:label-text (val->str tag)
            :disabled   (boolean disabled)
            :buttons    [{:icon        i/remove
                          :description (tr [:remove])
                          :on-click    #(swap-fn! disj tag)}]}])]])))
